import { StaticI18nLink } from "../../Link";
import styles from "./header.module.scss";
import common from "../../../styles/common.module.scss";
import { useMenuMobile } from "../../../hooks/useMenuMobile";
import { FiMenu } from "react-icons/fi";
import Link from "next/link";
import { utilityLinks } from "../../../data/contact-info";

const Header = () => {
	const menuMobile = useMenuMobile();

	return (
		<header id="header" className={`${styles.container} ${common.container}`}>
			<a href="https://verzel.com.br/" target="_blank" rel="noreferrer">
				<img
					src="/landings/assets/images/logo_icon_verzel.svg"
					alt="Logo verzel"
				/>
			</a>

			<FiMenu
				className={styles.menu_hamburguer}
				onClick={() => menuMobile.handleToggleMenu()}
			/>
			<nav className={styles.navigation}>
				<ul>
					<li>
						<StaticI18nLink href="/">
							<a target="_blank" title="Sobre a Verzel link">
								Sobre a Verzel
							</a>
						</StaticI18nLink>
					</li>
					<li>
						<StaticI18nLink href="/#contact-us">
							<a title="Contato link">Contato</a>
						</StaticI18nLink>
					</li>
					<li>
						<StaticI18nLink href="#devaria">
							<a title="Devaria">Devaria</a>
						</StaticI18nLink>
					</li>
					<li>
						<Link href={utilityLinks.workWithUs}>
							<a
								target="_blank"
								title="Trabalhe conosco link"
								rel="noreferrer"
							>
								Trabalhe conosco
							</a>
						</Link>
					</li>
				</ul>
			</nav>
		</header>
	);
};

export default Header;
